module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch6",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "14",
      "id": "pg_14",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("Fabric Types")])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Fabric falls into two main categories: dress (or fashion) weight and upholstery/curtain (or home dec) fabric. As bag makers, we can use both types – dress-weight fabric is generally better suited to bag linings and upholstery fabric is better for bag exteriors, However, that is only a loose rule and there are interfacing tricks that you can apply to your fabrics to override that rule. Here are some fabric suggestions that work a treat for bag making.")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "213",
      "src": "images/pg14-1.jpg",
      "width": "213"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('b', [_vm._v("Cotton/quilt fabric")]), _vm._v(" – this type of fabric is used both in the lining and the exterior of bags. Cotton is available in many different weights, but for bag making try to use mid-weight cotton and up. Quilting fabric is usually made from cotton and comes in a fantastic array of colourful, beautiful and fun prints. You can use cotton for almost any type of bag.")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "213",
      "src": "images/pg14-2.jpg",
      "width": "213"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('b', [_vm._v("Laminated cloth/oilcloth")]), _vm._v(" – usually used for the exterior of bags, this vinyl-coated fabric comes in fantastic prints and has a tough waterproof surface, making it perfect for swim bags, travel bags and wash bags. Working and stitching with laminated cloth is a bit different to working with woven fabrics, see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#tip"
    }
  }, [_vm._v("tip")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter7#wor"
    }
  }, [_vm._v("Working with laminated cotton")]), _vm._v(" overleaf.")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "213",
      "src": "images/pg14-3.jpg",
      "width": "214"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('b', [_vm._v("Linen")]), _vm._v(" – this versatile, hardwearing and natural fabric is available in both dress and home dec weight. The linen that bag makers like to use is the natural biscuit-coloured home dec weight fabric. The colour of the undyed cloth with its attractive irregular weave makes it a great foil for embroidery and/or patterned fabrics.")]), _vm._v(" "), _c('div', {
    staticClass: "tip",
    attrs: {
      "id": "tip"
    }
  }, [_c('p', {
    staticClass: "TIPH"
  }, [_c('samp', {
    staticClass: "SANS_Tiva_Heavy"
  }, [_vm._v("Oilcloth know-how …")])]), _vm._v(" "), _c('p', {
    staticClass: "TIP-TEXT"
  }, [_c('samp', {
    staticClass: "SANS_Tiva_Regular_17"
  }, [_vm._v("If you plan to sew with laminated cloth regularly, it is worth investing in a")]), _vm._v(" "), _c('samp', {
    staticClass: "SANS_Tiva_Regular_17"
  }, [_vm._v("non-stick")]), _vm._v(" "), _c('samp', {
    staticClass: "SANS_Tiva_Regular_17"
  }, [_vm._v("sewing machine foot.")])])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "203",
      "src": "images/pg15-1.jpg",
      "width": "203"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('span', {
    attrs: {
      "aria-label": "15",
      "id": "pg_15",
      "role": "doc-pagebreak"
    }
  }, [_c('b', [_vm._v("Canvas/denim")]), _vm._v(" – usually used for the exterior of bags, canvas is available in different weights. Choose the heaviest weight that your sewing machine can cope with. Canvas is strong and it has rugged good looks. Be sure to use a jeans needle when sewing with canvas and denim. I think canvas looks best on larger bags such as shoppers, messenger bags, travel bags and beach bags.")])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "213",
      "src": "images/pg15-2.jpg",
      "width": "213"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('b', [_vm._v("Velvet")]), _vm._v(" – this is a luxury fabric that has fabulous depth of colour and a strokeable texture. The nicest velvet is made from cotton. Velvet is available in different weights – choose the heaviest weight that your sewing machine can cope with. Velvet frays easily so it’s wise to sew with a wider seam allowance. If your velvet is quite thick or you will be sewing through a few layers use a jeans needle. Try using velvet for handbags, clutches and special occasion bags. Corduroy is similar to velvet in its uses and material qualities.")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "212",
      "src": "images/pg15-3.jpg",
      "width": "213"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('b', [_vm._v("Wool/suiting fabric")]), _vm._v(" – usually used for the exterior of bags, wool is fabulous for bag making. Wool is available in different weights, patterns and textures. Its incredible depth of colour and its yummy texture make wool a luxurious fabric to work with and use. Wool is hardwearing, but for bag making it usually requires interfacing of some kind. Wool has a more open weave so a strong dressmaking needle is sufficient. Try using wools for handbags, clutches and messenger bags.")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "213",
      "src": "images/pg15-4.jpg",
      "width": "213"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('b', [_vm._v("Silk/satin")]), _vm._v(" – used both as the exterior or lining, silks and satins are luxury fabrics that have beautiful looks, texture and movement. Silk looks gorgeous pleated or gathered. Try to stick to heavier weight silk/satin because it’s more durable and easier to sew with, while fine silk and satin are very slippery. Natural dupion silk is sturdy, has a lovely soft sheen and an interesting texture from the small slubs in the fabric. Shimmery satin fabric makes a glamorous lining in an evening bag. Use a fine sewing machine needle when sewing with silk or satin. Try using silk or satin for any special-occasion bags and purses.")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "210",
      "src": "images/pg15-5.jpg",
      "width": "211"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('b', [_vm._v("Faux/real suede")]), _vm._v(" – usually used for the exterior of bags, faux suede is similar in nature to velvet. Real suede is dense and harder to sew through than woven faux suede. If you feel that suede is too fragile for your bags it can be strengthened with interfacing. Be sure to use a leather needle for sewing suede. Try using real suede for smaller special-occasion bags and small handbags. Real and faux leather is similar in its uses to suede but has a shiny surface, often requiring a non-stick sewing machine foot.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578040e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter6.vue
// module id = 81
// module chunks = 0